if (!customElements.get('funto-aplus-sync')) {
  customElements.define('funto-aplus-sync', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.variants = JSON.parse(this.querySelector('[data-aplus-variants]').textContent);
      this.intros = JSON.parse(this.querySelector('[data-aplus-intros]').textContent);
      this.panelCopies = JSON.parse(this.querySelector('[data-aplus-panel-copies]').textContent);
      this.onChange = () => {
        this.sync();
        [100, 400, 1000, 2200].forEach(delay => setTimeout(() => this.sync(), delay));
      };
      this.onSectionLoad = () => { this.sync(true); this.setupTabs(); };
      document.addEventListener('change', this.onChange);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.timer = setInterval(() => { if (!document.hidden) this.sync(); }, 400);
      this.sync(true);
      this.setupTabs();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.started = false;
    }
    sync(force = false) {
      if (!this.isConnected) return;
      const fields = Array.from(document.querySelectorAll('main form[action*="/cart/add"] input[name="id"]'));
      const field = fields.find(input => input.closest('product-form') && Object.hasOwn(this.variants, input.value)) || fields.find(input => !input.closest('form')?.id.includes('installment') && Object.hasOwn(this.variants, input.value)) || fields.find(input => Object.hasOwn(this.variants, input.value));
      const urlVariant = new URL(location.href).searchParams.get('variant');
      const id = field?.value || (Object.hasOwn(this.variants, urlVariant) ? urlVariant : this.dataset.initialVariant);
      if (!force && id === this.currentVariant) return;
      this.currentVariant = id;
      const sku = this.variants[id];
      const active = !!sku;
      document.querySelectorAll('[data-funto-aplus-section]').forEach(section => {
        section.hidden = !active;
        section.querySelectorAll('[data-aplus-slot]').forEach(slot => {
          let matched = false;
          slot.querySelectorAll('[data-aplus-sku]').forEach(picture => {
            const visible = picture.dataset.aplusSku === sku;
            picture.hidden = !visible;
            matched ||= visible;
          });
          const panel = slot.closest('[data-aplus-panel]');
          if (panel) panel.hidden = !matched;
        });
        const intro = section.querySelector('[data-aplus-intro]');
        if (intro && this.intros[sku]) intro.textContent = this.intros[sku];
        const copy = this.panelCopies[sku];
        if (copy) {
          [['[data-aplus-tab-label]', 'aplusTabLabel', 'label'], ['[data-aplus-panel-title]', 'aplusPanelTitle', 'title'], ['[data-aplus-panel-body]', 'aplusPanelBody', 'body']].forEach(([selector, key, field]) => {
            section.querySelectorAll(selector).forEach(element => {
              const item = copy[Number(element.dataset[key])];
              if (item) element.textContent = item[field];
            });
          });
        }
        section.querySelectorAll('[data-aplus-option]').forEach(row => {
          const selected = row.dataset.aplusOption === sku;
          row.toggleAttribute('data-selected', selected);
          const link = row.querySelector('a');
          if (selected) link?.setAttribute('aria-current', 'true');
          else link?.removeAttribute('aria-current');
        });
      });
      document.querySelectorAll('[data-compare-sku]').forEach(column => { column.toggleAttribute('data-current-kit', column.dataset.compareSku === sku || (column.dataset.compareSku === 'FT1076A' && document.querySelectorAll('[data-compare-sku^="FT1076"]').length === 1 && ['FT1076A','FT1076B','FT1076CX','FT1076DX'].includes(sku))); });
      document.querySelectorAll('[data-aplus-legacy]').forEach(section => { section.hidden = sku !== 'FT1079'; });
    }
    setupTabs() {
      document.querySelectorAll('.funto-aplus-A02 [data-funto-kit-tabs], .funto-aplus-A02 content-tabs').forEach(tabs => {
        if (tabs.dataset.aplusReady) return;
        tabs.dataset.aplusReady = 'true';
        const list = tabs.querySelector('.content-tabs__buttons');
        const buttons = Array.from(tabs.querySelectorAll('.content-tab-button'));
        const panels = Array.from(tabs.querySelectorAll('.content-tab'));
        list?.setAttribute('role', 'tablist');
        const prefix = tabs.closest('.shopify-section')?.id || 'funto-kit-tabs';
        const select = index => buttons.forEach((button, i) => {
          const active = i === index;
          button.classList.toggle('content-tab-button--active', active);
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          if (panels[i]) {
            panels[i].classList.toggle('content-tab--active', active);
            panels[i].hidden = !active;
            panels[i].setAttribute('aria-hidden', String(!active));
          }
        });
        buttons.forEach((button, i) => {
          button.id = prefix + '-tab-' + i;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', prefix + '-panel-' + i);
          if (panels[i]) {
            panels[i].id = prefix + '-panel-' + i;
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].setAttribute('aria-labelledby', button.id);
          }
          button.addEventListener('click', event => {
            event.preventDefault(); event.stopImmediatePropagation(); select(i);
          }, true);
          button.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (i + 1) % buttons.length;
            if (event.key === 'ArrowLeft') next = (i + buttons.length - 1) % buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = buttons.length - 1;
            if (next === undefined) return;
            event.preventDefault(); event.stopImmediatePropagation(); select(next); buttons[next].focus();
          }, true);
        });
        select(Math.max(0, buttons.findIndex(button => button.classList.contains('content-tab-button--active'))));
      });
    }
  });
}


if (!customElements.get('funto-travel-compare')) {
  customElements.define('funto-travel-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.scroller = this.querySelector('[data-compare-scroll]');
      this.buttons = [...this.querySelectorAll('[data-compare-direction]')];
      if (!this.scroller) return;
      this.onClick = event => {
        const button = event.target.closest('[data-compare-direction]');
        if (!button || !this.contains(button)) return;
        const direction = Number(button.dataset.compareDirection);
        const rtl = getComputedStyle(this.scroller).direction === 'rtl';
        const distance = this.querySelector('thead th:nth-child(2)')?.getBoundingClientRect().width || 235;
        this.scroller.scrollBy({left: direction * distance * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.onScroll = () => {
        const position = Math.abs(this.scroller.scrollLeft);
        const end = this.scroller.scrollWidth - this.scroller.clientWidth;
        this.buttons.forEach(button => { button.disabled = Number(button.dataset.compareDirection) < 0 ? position <= 1 : position >= end - 1; });
      };
      this.addEventListener('click', this.onClick);
      this.scroller.addEventListener('scroll', this.onScroll, {passive:true});
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.scroller);
      this.onScroll();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.scroller?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      this.ready = false;
    }
  });
}

